module.exports = __webpack_public_path__ + "img/zhyly-8.8f5b65d0.png";